module.exports = __webpack_public_path__ + "961e2571f45d9b02.svg";